import translator from '../localization/translator.js';

export const showNoNameInsteadOfEmptyString = str => {
  if (!str) return translator.translate('noName');
  return str;
};

export const noname = showNoNameInsteadOfEmptyString;
